// ── Iyanna Chess — Design System v2 "Charcoal & Green" ──────────────────
// One source of truth for the chess UI. New identity per Iyanna's
// direction: soft charcoal (light black) surfaces, NO gold anywhere,
// and a living green accent that signals PLAY.

export const C = {
  // Backgrounds (layered charcoal depth — "nyeusi nyepesi")
  bg0: '#141816',      // deepest
  bg1: '#1B201E',      // panel base
  bg2: '#232927',      // raised card
  bgGradient: 'radial-gradient(circle at 30% 0%, #262D2A 0%, #1B201E 48%, #121614 100%)',

  // Accent — green means "cheza"
  accent: '#34D399',
  accentBright: '#4ADE80',
  accentDeep: '#0E9F6E',
  // Legacy token names kept so older styles keep compiling — remapped to
  // the new palette (gold is GONE by design).
  gold: '#34D399',
  goldSoft: '#6EE7A8',
  goldDeep: '#0E9F6E',
  orange: '#10B981',
  orangeSoft: '#34D399',

  // Greens
  green: '#2E9E6B',
  greenBright: '#3FBE83',
  greenDeep: '#0E5B3C',

  // Neutrals
  cream: '#EDF1EE',
  text: '#ECEFEA',
  textDim: 'rgba(236,239,234,0.6)',
  textFaint: 'rgba(236,239,234,0.38)',

  // Feedback
  danger: '#F87171',
  dangerSoft: '#FCA5A5',
  success: '#4ADE80',

  // Lines
  line: 'rgba(255,255,255,0.08)',
  lineStrong: 'rgba(255,255,255,0.15)',
};

export const RADIUS = { sm: '10px', md: '14px', lg: '18px', xl: '24px', pill: '99px' };

export const SHADOW = {
  card: '0 8px 28px rgba(0,0,0,0.4)',
  raised: '0 12px 34px rgba(0,0,0,0.5)',
  gold: '0 8px 26px rgba(52,211,153,0.25)',   // legacy name, green glow now
  green: '0 8px 24px rgba(52,211,153,0.28)',
};

export const FONT = {
  display: "'Fraunces', Georgia, serif",
  body: "'Plus Jakarta Sans', system-ui, sans-serif",
  mono: "'DM Mono', ui-monospace, monospace",
};

// Reusable button styles
export const BTN = {
  primary: {
    background: `linear-gradient(135deg, ${C.accentDeep}, ${C.accent})`,
    color: '#06281A', border: 'none', padding: '15px 24px', borderRadius: RADIUS.md,
    fontSize: '15px', fontWeight: '800', cursor: 'pointer', fontFamily: FONT.body,
    boxShadow: '0 8px 22px rgba(16,185,129,0.3)', letterSpacing: '0.2px',
  },
  gold: { // legacy name — now the green "play" button
    background: `linear-gradient(135deg, ${C.accent}, ${C.accentDeep})`,
    color: '#06281A', border: 'none', padding: '14px 22px', borderRadius: RADIUS.md,
    fontSize: '14.5px', fontWeight: '800', cursor: 'pointer', fontFamily: FONT.body,
    boxShadow: SHADOW.green,
  },
  ghost: {
    background: 'rgba(255,255,255,0.06)', color: C.text,
    border: `1px solid ${C.lineStrong}`, padding: '13px 20px', borderRadius: RADIUS.md,
    fontSize: '13.5px', fontWeight: '700', cursor: 'pointer', fontFamily: FONT.body,
  },
};
